import { useState, useEffect } from 'react';
import { fetchTowns } from '../../../services/api';

const useTowns = () => {
  const [towns, setTowns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadTowns = async () => {
      try {
        setLoading(true);
        const data = await fetchTowns();
        setTowns(Array.isArray(data) ? data : data?.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadTowns();
  }, []);

  return { towns, loading, error };
};

export default useTowns;
